<template>
     
    <div class="px-2" style="{backgruond-color:white}">
      <HeaderBar/>
      <!-- search input -->
  
      <div class="d-flex justify-content-center mt-1 headTitle mt-4">
        Usuarios
      </div>
      <div class="d-flex justify-content-center mt-1 headTitle">
        {{fincaName}}
      </div>
      
      <!-- table -->
      
      <vue-good-table :columns="columns" :rows="rows" styleClass="vgt-table bordered"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm
        }" 
        
        :pagination-options="{
          enabled: true,
          perPage: pageLength
        }"
        
        :sort-options="{
          enabled: true,
        }"
      >
        <template slot="table-row" slot-scope="props">
  
          <!-- Column: Name -->
          <span v-if="props.column.field === 'action'" class="text-center">
            <a class="btn btn-danger btn-sm" @click="delUser(props.row.id)">x</a>
          </span>
  
          <!-- Column: Common -->
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
  
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap ">
                Mostrando 1 de
              </span>
              <b-form-select v-model="pageLength" :options="['25', '50', '100']" class="mx-1"
                @input="(value) => props.perPageChanged({ currentPerPage: value })" />
              <span class="text-nowrap"> of {{ props.total }} registros </span>
            </div>
          </div>
        </template>
      </vue-good-table>
      
      <AddButton preTitle="Agregar Usuario" goTo="basic-addusers"/>
      <ControlMenu />
    </div>
  </template>
  
  <script>
  import ControlMenu from '@/components/ControlMenu.vue'
  import HeaderBar from '@/components/HeaderBar.vue'
  import AddButton from '@/components/AddButton.vue'
  import vSelect from 'vue-select'
  import "vue-select/dist/vue-select.css";
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import {
    BAvatar, BBadge, BPagination, BFormGroup, BFormSelect, BFormCheckbox, BDropdown, BDropdownItem, BRow, BCol, BLink, BButton, BForm, BFormInput, BInputGroup, BImg,
  } from 'bootstrap-vue'
  import { VueGoodTable } from 'vue-good-table'
  import PlusButton2 from '@/components/PlusButton2.vue'
  import store from '@/store/index'
  import WheighinsLineChartVue from '../DataLog/Animal/WheighinsLineChart.vue';
  
  export default {
    components: {
      BRow,
      BImg,
      BCol,
      BLink,
      BButton,
      BForm,
      BFormCheckbox,
      BInputGroup,
      VueGoodTable,
      vSelect,
      PlusButton2,
      ValidationProvider,
      ValidationObserver,
      BFormCheckbox,
      BAvatar,
      BBadge,
      BPagination,
      BFormGroup,
      BFormInput,
      BFormSelect,
      BDropdown,
      BDropdownItem,
      ControlMenu,
      HeaderBar,
      AddButton,
      WheighinsLineChartVue,
    },
    data() {
      return {
        fincaName:localStorage.getItem('currentFarmName'),
        currAmimal:0,
        pageLength: 25,
        dir: false,
        status1: null,
        status2: null,
        modalShow: false,
        modalCase: 0,
        editShow:false,
        modalTrashShow:false,
        columns: [
          {
            label:  'ID',
            field:  'id',
            type:   'string'
          },  
          {
            label:  'USUARIO',
            field:  'name',
            type:   'string'
          },
          {
            label:  'CORREO',
            field:  'email',
            type:   'string'
          },
          {
            label:  'ACCESO',
            field:  'level',
            type:   'string'
          },
          {
            label: '',
            field: 'action',
          },
  
        ],
        rows: [],
        animalData:[],
        animal:{
          weight:0,
          age:0,
        },
        weighinsData:{
          labels:[],
          datasets: [
            { label:'Evolución de peso',
              backgroundColor: '#5E8F23',
              data:[]
            }
          ]
        },
        chartOptions:{
          responsive: true,
          maintainAspectRatio: false,
          backgroundColor: false,
          hover: {
            mode: 'label',
          },
          layout: {
            padding: {
              top: 0,
              bottom: 0,
              left: 0,
              right:20
            },
          },
          
          legend: {
            position: 'top',
            align: 'start',
            labels: {
              usePointStyle: true,
              padding: 25,
              boxWidth: 9,
            },
          },
        },
        weighins:{
          observations:'',
          animal_id:this.currAmimal,
          weight:0,
          date:''
        },
        searchTerm: '',
        /*chartOptions: {
          responsive: true,
          maintainAspectRatio: false
        }*/
      }
    },
    computed: {
      statusVariant() {
        const statusColor = {
          /* eslint-disable key-spacing */
          Current: 'light-primary',
          Professional: 'light-success',
          Rejected: 'light-danger',
          Resigned: 'light-warning',
          Applied: 'light-info',
          /* eslint-enable key-spacing */
        }
  
        return status => statusColor[status]
      },
      direction() {
        if (store.state.appConfig.isRTL) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.dir = true
          return this.dir
        }
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = false
        return this.dir
      },
    },
    methods:{
      async fetchUsersFarms(config){
        let farmId= localStorage.getItem('currentFarm');
        fetch(this.$apiUrl+"list/UsersFarmView?farm_id="+farmId, config)
          .then(response => response.json())
          .then(result => {
              console.log(result.UsersFarmView);
              this.rows = result.UsersFarmView.map(item => {return {id:item.id,document:item.poisition,name:item.names,email:item.email, level:item.level}});
              
          })
      },
  
      delUser(idItem){
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        let self=this;

        this.$swal({
          title: 'Eliminar registro',
          text: '¿Seguro que desea eliminar el registro?',
          type: 'warning',
          icon:'warning',
          showCancelButton: false,
          confirmButtonText:'Si',
          showDenyButton: true,
          denyButtonText:'No',
          confirmButtonColor:'#5E8F23',
          showCloseButton: false,
          showLoaderOnConfirm: false  
        }).then((result)=>{
          if(result.isConfirmed){
            this.$http.get(this.$apiUrl+'delete/user_farm_access/'+idItem,config)
            .then(function(){
              self.$router.go(0);
            });
          }
        });
      }
    },
    created() {
      const token = localStorage.getItem("accessToken");
      const config = {headers: {"X-Authorization": `Bearer ${token}`}};
      this.fetchUsersFarms(config);
    },
  }
  </script>
  <style lang="scss">
  body {
    background-color: white !important;
  }
  table{
      width: 100% !important;
    }
    td{
      padding-left: 10px;
      padding-right: 10px;
    }
    .vgt-responsive{
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; 
}
  .subTitle {
    font-weight: 600;
    font-size: 23px;
  
  }
  
  .linkTitle {
  
    font-weight: 500;
    font-size: 14px;
    text-align: center;
    letter-spacing: 0.4px;
    color: #5E8F23;
  
  }
  
  .headTitle {
    font-weight: 600;
    font-size: 24px;
    color: #5E8F23;
  }
  
  thead{
    background-color: #5E8F23;
    text-align:center;
    color:#ffffff;
  }
  thead> tr{
    padding:5px;
  }
  .editAnimal {
    font-weight: 500;
    font-size: 18px;
  }
  
  
  .editModal {
    font-weight: 500;
    font-size: 18px;
  }
  
  span.text-center{
    display:flex;
    justify-content: center;
    text-align: center;
  }
  </style>